import { mapping as deviceMapping } from '../common/device-base/device-base-sort.mapper'

export const mapping: Record<string, string> = {
  ...deviceMapping,
}

const mapSortPassageParam = (key: string) => mapping[key]

export default mapSortPassageParam
